module.exports = __webpack_public_path__ + "media/images/icons/enroll-14e21a3f0e7f4d4a0c8a5293a644a68b.svg";